import { SystemApi } from "../mainApi/apis/SystemApi";
import { InlineResponse20013 } from "../mainApi/models/InlineResponse20013";
import { IResponse, requestMachine } from "../requestMachine";

export default {
  getLinks(): Promise<IResponse<InlineResponse20013>> {
    return requestMachine<InlineResponse20013>(
      SystemApi,
      "getAgreementLinks",
      false
    );
  },

  getOrganization(): Promise<IResponse<InlineResponse20013>> {
    return requestMachine<InlineResponse20013>(
      SystemApi,
      "getOrganization",
      false
    );
  },
};
